import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    base: {
        height: '100%',
        width: '100%',
    },
    landing: {
        minHeight: 'calc(100dvh - 20px)',
        paddingBottom: '20px',
        height: '100%',
        paddingTop: '10px',
        width: '100%',
        backgroundColor: theme.palette.primary.main,
    },
    root: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        padding: theme.spacing(0, 2),
        backgroundColor: theme.palette.primary.main,
    },
    card: {
        width: 'clamp(420px, 50dvw, 800px)',
        maxWidth: '100%',
        overflow: 'visible',
        display: 'flex',
        position: 'relative',
        '& > *': {
            flexGrow: 1,
            flexBasis: '50%',
            width: '50%',
        },
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(6),
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        marginTop: 10,
        marginBottom: 10,
        color: '#444',
        display: 'flex',
        justifyContent: 'center'
    },
    dialogTitle: {
        background: theme.palette.primary.main,
        color: 'white',
        fontWeight: 'bold',
    },
    dialogActions: { margin: '0px 16px 16px 16px' },
    dialogContent: {},
    dialogContentText: {},
    submitButton: {
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(2),
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        width: '100%',
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
    },
    textInput: { marginTop: 8, width: '100%' },
    paperMargin: { padding: '20px', marginLeft: '10px', marginRight: '10px' },
    textDisplay: { display: 'flex', justifyContent: 'center' },
    paperLanding: { margin: '10px', padding: '20px', display: 'flex', flexDirection: 'column', gap: '20px' },
    buttonBox: { display: 'flex', flexDirection: 'column', gap: '10px', justifyContent: 'center', alignItems: 'center' },
}));
